import { GuestBookingTripLog } from "@/redux/slices/guest/types";
import { transformBookingTripLog } from "../booking/helpers";
import { RawGuestBookingTripLog } from "./types";

export const transformGuestBookingTripLog: (tripLog: RawGuestBookingTripLog) => GuestBookingTripLog = transformBookingTripLog;
